
import styles from './invictustest.module.css'
import eligibilityicon from '../../assets/eligibility_iat.svg'
const InvictusTestCriteria = () => {
    return (
        <>
            <div className={`${styles.partial_scroll}`}>
                <div className={`container ${styles.bg_mweb_invictus}`}  >
                    {/*-------- Invictus Test Criteria*/}
                    <div className={`${styles.mn_criteria}`}>
                        <div className={`${styles.test_detail_wrapper}`} style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }}>
                            <h2>Test details</h2>
                            <div className={`${styles.test_dt_three}`} style={{ maxWidth: '1120px' }}>
                                {/* box1 */}
                                <div className={`${styles.test_dt_box}`}>
                                    <div>
                                        <img
                                            src="https://d2flmtdfyoymgx.cloudfront.net/Aakash-Anthe/s3fs-public/inline-images/online-icon1.svg"
                                            alt=""
                                        />
                                    </div>
                                    <div>
                                        <h6>Online & Offline mode</h6>
                                        <p>
                                            Choose an exam mode of your convenience
                                        </p>
                                    </div>
                                </div>
                                <div className={`${styles.br_rt}`}></div>
                                {/* box1 */}
                                {/* box2 */}
                                <div className={`${styles.test_dt_box}`}>
                                    <div>
                                        <img
                                            src="https://d2flmtdfyoymgx.cloudfront.net/Aakash-Anthe/s3fs-public/inline-images/time-icon2.svg"
                                            alt=""
                                        />
                                    </div>
                                    <div>
                                        <h6>
                                            10AM - 1PM
                                        </h6>
                                        <p>Test timings</p>
                                    </div>
                                </div>
                                <div className={`${styles.br_rt}`}></div>
                                {/* box2 */}
                                {/* box3 */}
                                <div className={`${styles.test_dt_box}`}>
                                    <div>
                                        <img
                                            src="https://d2flmtdfyoymgx.cloudfront.net/Aakash-Anthe/s3fs-public/inline-images/watch-icon3.svg"
                                            alt=""
                                        />
                                    </div>
                                    <div>
                                        <h6>3 hours duration</h6>
                                        <p>Immersive test experience</p>
                                    </div>
                                </div>
                                <div className={`${styles.br_rt}`}></div>
                                {/* box3 */}
                                {/* box4 */}
                                <div className={`${styles.test_dt_box}`}>
                                    <div>
                                        <img
                                            src={eligibilityicon}
                                            alt=""
                                        />
                                    </div>
                                    <div>
                                        <h6>Eligibility</h6>
                                        <p>Class 8th, 9th, 10th, 11th, 12th studying students</p>
                                    </div>
                                </div>
                                {/* box4 */}
                            </div>
                        </div>
                    </div>
                    {/*------- Invictus Criteria*/}
                </div>
            </div>

        </>

    )
}

export default InvictusTestCriteria
